"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormulaFieldLogic = void 0;
var formula_fieldtype_1 = require("./formula.fieldtype");
Object.defineProperty(exports, "FormulaFieldLogic", { enumerable: true, get: function () { return formula_fieldtype_1.FormulaFieldLogic; } });
